var render = function render(){
  var _vm$message;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', {
    staticClass: "flex-nowrap ma-n4",
    class: {
      'mt-n12': _vm.isItemSequent
    },
    attrs: {
      "justify": "start"
    }
  }, [_c('v-col', {
    staticClass: "pa-4",
    style: {
      opacity: _vm.isItemSequent ? 0 : 1
    },
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-avatar', {
    attrs: {
      "color": "grey-f7",
      "height": "28px!important",
      "width": "28px!important"
    }
  }, [_c('v-img', {
    scopedSlots: _vm._u([{
      key: "placeholder",
      fn: function () {
        return [_c('v-icon', {
          attrs: {
            "small": "",
            "color": "grey lighten-2"
          }
        }, [_vm._v(" mdi-robot ")])];
      },
      proxy: true
    }])
  })], 1)], 1), _c('v-col', {
    staticClass: "pa-4"
  }, [_c('v-row', {
    staticClass: "ma-n4 flex-nowrap",
    attrs: {
      "align": "end"
    }
  }, [_c('v-col', {
    staticClass: "pa-4",
    staticStyle: {
      "max-width": "calc(100% - 36px)"
    },
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-card', {
    attrs: {
      "color": "grey-f7",
      "flat": "",
      "min-height": "36"
    }
  }, [_c('v-card-text', {
    staticClass: "py-8 px-12 font-size-14",
    staticStyle: {
      "word-break": "break-all"
    }
  }, [_vm._v(" " + _vm._s((_vm$message = _vm.message) === null || _vm$message === void 0 ? void 0 : _vm$message.content) + " ")])], 1)], 1), _c('v-col', {
    staticClass: "pa-4",
    style: {
      opacity: _vm.isTimeSequent ? 0 : 1
    },
    attrs: {
      "cols": "auto"
    }
  }, [_c('span', {
    staticClass: "font-size-10"
  }, [_vm._v(" " + _vm._s(_vm.time) + " ")])])], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }